<script setup>
import {ref, defineModel} from "vue";

const props = defineProps(['id', 'name']);

const mode = ref(true);
const model = defineModel();

function switchMode() {
    mode.value = !mode.value;
}
</script>

<template>
    <div class="relative">
        <input :type="mode ? 'password' : 'text'" v-model="model" :id="id" :name="name" class="w-full py-1 pl-2 pr-10">

        <button type="button" @click="switchMode" class="absolute right-0 top-1/2 -translate-y-1/2 px-2 py-1" tabindex="-1">
            <i class="fa-fw fa-solid fa-eye" v-if="mode"></i>
            <i class="fa-fw fa-solid fa-eye-slash" v-else></i>
        </button>
    </div>
</template>